<template>
	<div>
		<CCard class="p-2">
			<form @submit.prevent="submit">
				<CCardHeader>
					<CRow style="color: #1352a1;">
				
						<CCol lg="6">
							<h5 v-if="!editMode">New Vehicle</h5>
							<h5 v-else>Update Vehicle</h5>
						</CCol>
				     	<CCol lg="6">
				      		<div style="text-align: right">
				      			<CButton size="sm" class="btn btn-ghost-dark" @click="backToTable()"> Cancel</CButton> &nbsp; 
				      			<CButton class="px-3"  size="sm" color="info" type="submit" :disabled="isLoading"><i class="fa fa-save"></i> {{ isLoading ? ('Uploading... ' + uploadPercentage + '%') : 'Save' }}</CButton>
				      		</div>
						</CCol>
					</CRow>
				</CCardHeader>
				<CCardBody class="card-form">
                    <CCard class="pl-3 pr-3">
					<CRow class="mt-3">
                            <CCol lg="12">
                                <h6 >Vehicle Information </h6>
                                
                            </CCol>
                        </CRow>
                        <br/> 
						<CRow >
							<CCol lg="4">
								<label class="mb-1">Plate No. <span class="text-danger">*</span></label>
								<CInput
				                  v-model="dataParams.plate_no"
				                  required="true"
				                />
							</CCol>
							<CCol lg="4">
								<label class="mb-1">Body No. <span class="text-danger">*</span></label>
								<CInput
				                  v-model="dataParams.body_no"
				                  required="true"
				                />
							</CCol>
							<CCol lg="4">
								<div class="form-group"> 
									<label class="mb-1">Status <span class="text-danger">*</span></label>
									<v-select 
										label="setting_name" 
										:options="[
											{
												setting_name: 'Active',
												id: 'ACTIVE'
											},
											{
												setting_name: 'Inactive',
												id: 'INACTIVE'
											}, 
											// {
											// 	setting_name: 'Incoming',
											// 	id: 'INCOMING'
											// }, 
											{
												setting_name: 'Archive',
												id: 'ARCHIVE'
											},
                      {
												setting_name: 'Sold',
												id: 'SOLD'
											},
                       {
												setting_name: 'Scrap',
												id: 'SCRAP'
											},
											{
												setting_name: 'In-shop',
												id: 'IN-SHOP'
											},
											{
												setting_name: 'Out of Service',
												id: 'OUT OF SERVICE'
											},
										]"
										:reduce="item => item.id"
										v-model="dataParams.status"
										placeholder="-Select-" 
									>
										<template #search="{attributes, events}">
											<input
												class="vs__search"
												:required="!dataParams.status"
												v-bind="attributes"
												v-on="events"
											/>
										</template>
									</v-select>
								</div>
							</CCol>
						
						</CRow>
						<CRow >
							<CCol lg="4">
								<div class="form-group"> 
									<label class="mb-1">Vehicle Type <span class="text-danger">*</span></label>
									<v-select 
										label="setting_name" 
										:options="vehicleTypeList.data"
										:reduce="item => item.id"
										v-model="dataParams.vehicle_type_id"
										placeholder="-Select-" 
									>
										<template #search="{attributes, events}">
											<input
												class="vs__search"
												:required="!dataParams.vehicle_type_id"
												v-bind="attributes"
												v-on="events"
											/>
										</template>
									</v-select>
								</div>
							</CCol>
							
							
							<CCol lg="4">
								<div class="form-group"> 
									<label class="mb-1">Maker/Manufacturer <span class="text-danger">*</span></label>
									<v-select 
										label="setting_name" 
										:options="makerModelList.data"
										:reduce="item => item.id"
										v-model="dataParams.maker_model_id"
										
									>
										<template #search="{attributes, events}">
											<input
												class="vs__search"
												:required="!dataParams.maker_model_id"
												v-bind="attributes"
												v-on="events"
											/>
										</template>
									</v-select>
								</div>
							</CCol>
							<CCol lg="4">
								<div class="form-group"> 
									<label class="mb-1">Model <span class="text-danger">*</span></label>
									<v-select 
										label="setting_name" 
										:options="vehicleModelList.data"
										:reduce="item => item.id"
										v-model="dataParams.model_id"
										
									>
										<template #search="{attributes, events}">
											<input
												class="vs__search"
												:required="!dataParams.model_id"
												v-bind="attributes"
												v-on="events"
											/>
										</template>
									</v-select>
								</div>
							</CCol>
						
						</CRow>
						<CRow >
							<CCol lg="4">
								<div class="form-group">
									<label class="mb-1">Year</label>
									<CInput
					              
					                  v-model="dataParams.year" 
					                /> 
								</div> 
							</CCol> 
							
							
							<CCol lg="4">
								<div class="form-group"> 
									<label class="mb-1">Commodity Type </label>
									<v-select 
										label="setting_name" 
										:options="commodityTypeList.data"
										:reduce="item => item.id"
										v-model="dataParams.commodity_type_id"
										placeholder="-Select-" 
									>
										
									</v-select>
								</div>
							</CCol>
							<CCol lg="4">
								<label class="mb-1">Asset No.</label>
								<CInput
				                 
				                  v-model="dataParams.asset_no"
				                />
							</CCol>
							
						</CRow>
            <CRow >
							<CCol lg="4">
								<div class="form-group">
									<label class="mb-1">Category Type</label>
									<v-select 
										label="text" 
										:options="[	{value: 'primary', text: 'Primary'},
													{value: 'secondary', text: 'Secondary'},
													{value: 'OTO', text: 'OTO (Own To Operate)'},
                           {value: 'OTW', text: 'OTW'},
                           {value: 'RENTAL', text: 'Rental'}
													]"
											
										:reduce="item => item.value"
										v-model="dataParams.category_type"
										
									>
			
									</v-select>
								</div> 
							</CCol> 
						</CRow>
							
							
				</CCard>
				<CCard class="pl-3 pr-3">	
						<CRow class="mt-3">
								<CCol lg="12">
									<h6 >Vehicle Location </h6>
									
								</CCol>
						</CRow>
                        <br/> 
						<CRow >
							<CCol lg="4">
								<div class="form-group">
									<!-- <label for="exampleInputEmail1"> </label>  -->
									<CInputCheckbox 
										:label="'Company owned?'"
										:checked="dataParams.company_owned == 1 ? true : false"
					                    @update:checked="updateCompanyOwned" 
				                    /> 
					            </div>
							</CCol>
							
						</CRow>
							<CRow >
							
							<CCol lg="12">
								<div class="form-group" v-if="!dataParams.company_owned"> 
									<label class="mb-1">Subcon (Trucker)</label>
									<v-select 
										label="vendor_name" 
										:options="vendorList.data"
										:reduce="item => item.id"
										v-model="dataParams.vendor_id"
										placeholder="-Select-" 
									> 
									</v-select>
								</div>
							</CCol> 
						</CRow>
						<CRow >
							<CCol lg="4">
								<div class="form-group"> 
									<label class="mb-1">Origin</label>
									<v-select 
										label="setting_name" 
										:options="originList.data"
										:reduce="item => item.id"
										v-model="dataParams.origin_id"
										placeholder="-Select-" 
									> 
									</v-select>
								</div>
							</CCol>
							<CCol lg="4">
								<div class="form-group"> 
									<label class="mb-1">Depot</label>
									<v-select 
										:disabled="depot_id != null"
										label="setting_name" 
										:options="depotList.data"
										:reduce="item => item.id"
										v-model="dataParams.location"
										placeholder="-Select-" 
									> 
									</v-select>
								</div>
							</CCol>
							<CCol lg="4">
								<div class="form-group"> 
									<label class="mb-1">With GPS?</label>
									<v-select 
										label="setting_name" 
										:options="[
											{
												setting_name: 'Yes',
												id: 'yes'
											},
											{
												setting_name: 'No',
												id: 'no'
											},
										]"
										:reduce="item => item.id"
										v-model="dataParams.with_gps"
										
									> 
									</v-select>
								</div>
						</CCol> 
               
							
						</CRow>
						
				</CCard>
				<CCard class="pl-3 pr-3" v-if="is_monocrete()">	
						<CRow class="mt-3">
								<CCol lg="12">
									<h6 >Project Information </h6>
									
								</CCol>
						</CRow>
						<CRow >
								<CCol lg="6">
								<div class="form-group"> 
									<label class="mb-1">Project/Dept</label>
									<v-select 
										label="customer_name" 
										:options="customerList.data"
										:reduce="item => item.id"
										v-model="dataParams.project_id"
										placeholder="-Select-" 
									> 
									</v-select>
								</div>
							</CCol>
							<CCol lg="6">
								<div class="form-group">
									<label class="mb-1">Transfer Date</label>
									<Datepicker 
										input-class="form-control bg-white" 
										v-model="dataParams.transfer_date"
										
									>
									</Datepicker> 
								</div> 
							</CCol>
              <CCol lg="6">
                      <div class="form-group">
                        <label style="font-size: 12px" class="mb-1"
                          >Current Location</label
                        >
                        <v-select
                        @input="locationChanged($event)"
                          label="customer_name"
                          :options="currentLocationList.data"
                          :reduce="(item) => item.id"
                          v-model="dataParams.current_location" 
                          placeholder="-Select-"
                        >
                        
                        </v-select>
                      </div>
            </CCol>
						
						</CRow>
						
				</CCard>		
				<CCard class="pl-3 pr-3">	
						<CRow class="mt-3">
								<CCol lg="12">
									<h6 >Specifications </h6>
									
								</CCol>
						</CRow>
						<br/>
						
                        <CRow >
							<CCol lg="4">
								<label class="mb-1">Chassis No.</label>
								<CInput
				                 
				                  v-model="dataParams.chassis_no" 
				                />
							</CCol>
						
							<CCol lg="4">
								<label class="mb-1">Color</label>
								<CInput
				                
				                  v-model="dataParams.color" 
				                />
							</CCol>
							<CCol lg="4">
								<label class="mb-1">Engine No.</label>
								<CInput
				                 
				                  v-model="dataParams.engine_no"
				                />
							</CCol>
							<CCol lg="4">
								<label class="mb-1">Engine Size</label>
								<CInput
				                 
				                  v-model="dataParams.engine_size" 
				                />
							</CCol>
						
							<CCol lg="4">
								<div class="form-group"> 
									<label class="mb-1">Fuel Type</label>
									<v-select 
										label="setting_name" 
										:options="[
											{
												setting_name: 'Gasoline',
												id: 'GASOLINE'
											},
											{
												setting_name: 'Diesel',
												id: 'DIESEL'
											},
										]"
										:reduce="item => item.id"
										v-model="dataParams.fuel_type"
										placeholder="-Select-" 
									> 
									</v-select>
								</div>
							</CCol>
							<CCol lg="4">
								<div class="form-group"> 
									<label class="mb-1">Transmission Type</label>
									<v-select 
										label="setting_name" 
										:options="[
											{
												setting_name: 'Manual',
												id: 'MANUAL'
											},
											{
												setting_name: 'Automatic',
												id: 'AUTOMATIC'
											},
										]"
										:reduce="item => item.id"
										v-model="dataParams.transmission_type"
										placeholder="-Select-" 
									> 
									</v-select>
								</div>
							</CCol>
							
						</CRow>
				</CCard>

				<CCard class="pl-3 pr-3">	
					<CRow class="mt-3">
						<CCol lg="12">
							<h6>Registration & Compliance</h6>
						</CCol>
					</CRow>
					<br/>
					<CRow>
						<CCol lg="4">
							<div class="form-group"><label class="mb-1">OR Date</label><Datepicker input-class="form-control bg-white" v-model="dataParams.or_date"></Datepicker></div>
						</CCol>
						<CCol lg="4"><label class="mb-1">OR Number</label><CInput v-model="dataParams.or_no" /></CCol>
						<CCol lg="4"><div class="form-group"><label class="mb-1">CR Date</label><Datepicker input-class="form-control bg-white" v-model="dataParams.cr_date"></Datepicker></div></CCol>
						<CCol lg="4"><label class="mb-1">CR Number</label><CInput v-model="dataParams.cr_no" /></CCol>
						<CCol lg="4"><label class="mb-1">LTFRB Case No.</label><CInput v-model="dataParams.ltfrb_case_no" /></CCol>
						<CCol lg="4"><div class="form-group"><label class="mb-1">LTFRB Expiry Date</label><Datepicker input-class="form-control bg-white" v-model="dataParams.ltfrb_expiry"></Datepicker></div></CCol>
						<CCol lg="4"><label class="mb-1">M.V. File No.</label><CInput v-model="dataParams.mv_file_no" /></CCol>
						<CCol lg="4"><div class="form-group"><label class="mb-1">P.A Expiry Date</label><Datepicker input-class="form-control bg-white" v-model="dataParams.pa_date"></Datepicker></div></CCol>
						<CCol lg="4"><div class="form-group"><label class="mb-1">Late Renewal Date</label><Datepicker input-class="form-control bg-white" v-model="dataParams.later_renewal_date"></Datepicker></div></CCol>
						<CCol lg="4">
							<div class="form-group"> 
								<label class="mb-1">Registration Type</label>
								<v-select label="setting_name" :options="[{ setting_name: 'For Hire', id: 'FOR HIRE' }, { setting_name: 'Private', id: 'PRIVATE' }]" :reduce="item => item.id" v-model="dataParams.registration_type" placeholder="-Select-"></v-select>
							</div>
						</CCol>
						<CCol lg="4"><div class="form-group"><label class="mb-1">Registration Date</label><Datepicker input-class="form-control bg-white" v-model="dataParams.registration_date"></Datepicker></div></CCol>
						<CCol lg="4">
							<div class="form-group"> 
								<label class="mb-1">RFID Type</label>
								<v-select label="setting_name" :options="[{ setting_name: 'Auto Sweep', id: 'Auto Sweep' }, { setting_name: 'Easty Trip', id: 'Easty Trip' }, { setting_name: 'None', id: 'None' }]" :reduce="item => item.id" v-model="dataParams.rfid_type" placeholder="-Select-"></v-select>
							</div>
						</CCol>
						<CCol lg="4"><label class="mb-1">RFID Account No.</label><CInput v-model="dataParams.rfid_account_no" /></CCol>
					</CRow>
		        </CCard>

				<CCard class="pl-3 pr-3">
					<CRow class="mt-3">
						<CCol lg="12">
							<h6>Insurance</h6>
						</CCol>
					</CRow>
					<br/>
					<CRow>
						<CCol lg="12"><label class="mb-1">Insurance Provider</label><CInput v-model="dataParams.insurance_provider" /></CCol>
						<CCol lg="6"><label class="mb-1">Insurance Policy No.</label><CInput v-model="dataParams.insurance_policy_no" /></CCol>
						<CCol lg="6"><div class="form-group"><label class="mb-1">Insurance Expiry Date</label><Datepicker input-class="form-control bg-white" v-model="dataParams.insurance_expiry"></Datepicker></div></CCol>
						<CCol lg="6"><label class="mb-1">Inland Marine Policy No.</label><CInput v-model="dataParams.in_marine_policy_no" /></CCol>
						<CCol lg="6"><div class="form-group"><label class="mb-1">Inland Marine Expiry Date</label><Datepicker input-class="form-control bg-white" v-model="dataParams.in_marine_expiry"></Datepicker></div></CCol>
					</CRow>
				</CCard>

				<CCard class="pl-3 pr-3">
					<CRow class="mt-3">
						<CCol lg="12">
							<h6>Acquisition & Condition</h6>
						</CCol>
					</CRow>
					<br/>
					<CRow>
						<CCol lg="4"><div class="form-group"><label class="mb-1">Acquisition Date</label><Datepicker input-class="form-control bg-white" v-model="dataParams.acquisition_date"></Datepicker></div></CCol>
						<CCol lg="4"><label class="mb-1">Acquisition Price</label><CInput v-model="dataParams.acquisition_price" /></CCol>
						<CCol lg="4"><div class="form-group"><label class="mb-1">Breakdown Date</label><Datepicker input-class="form-control bg-white" v-model="dataParams.breakdown_date"></Datepicker></div></CCol>
						<CCol lg="4"><div class="form-group"><label class="mb-1">Breakdown Remarks</label><CInput input-class="form-control bg-white" v-model="dataParams.breakdown_remarks"></CInput></div></CCol>
						<CCol lg="12"><label class="mb-1">Remarks</label><CInput v-model="dataParams.remarks" /></CCol>
					</CRow>
				</CCard>
				
				<CCard class="vehicle-media-card mb-3">
					<CCardBody class="vehicle-media-card-body py-3 px-3">
						<h6 class="vehicle-media-card-title mb-3">Vehicle photo &amp; documents</h6>
						<CRow class="vehicle-media-row align-items-start">
							<CCol lg="4" md="5" class="vehicle-media-photo-col">
								<label for="default_vehicle_photo" class="vehicle-media-label">Vehicle picture</label>
								<small v-if="selectedVehiclePhotoSizeLabel" class="text-muted"> ({{ selectedVehiclePhotoSizeLabel }})</small>
								<small
									v-if="editMode && dataParams.vehicle_photo && !selectedVehiclePhotoSizeLabel"
									class="text-muted d-block vehicle-media-hint"
								>Current photo below — choose a file to replace.</small>
								<input
									type="file"
									class="vehicle-media-file-input"
									id="default_vehicle_photo"
									accept=".jpg,.jpeg,.png"
								>
								<small v-if="fileErrors.vehicle_photo" class="text-danger d-block mt-1">{{ fileErrors.vehicle_photo }}</small>
								<label class="vehicle-photo-preview-box" for="default_vehicle_photo">
									<img
										class="vehicle-photo-preview-img"
										id="display_default_vehicle_photo"
										src="https://t3.ftcdn.net/jpg/02/48/42/64/360_F_248426448_NVKLywWqArG2ADUxDq6QprtIzsF82dMF.jpg"
										v-if="!dataParams.vehicle_photo"
										alt=""
									>
									<img
										class="vehicle-photo-preview-img"
										id="display_default_vehicle_photo"
										:src="dataParams.vehicle_photo"
										v-else
										alt="Vehicle"
									>
								</label>
							</CCol>
							<CCol lg="8" md="7" class="vehicle-media-docs-col">
								<label class="vehicle-media-label">Vehicle documents</label>
								<small class="text-muted d-block vehicle-media-hint">Single PDF for OR/CR, registration, insurance, and related documents (optional, max 25MB).</small>
								<div
									v-if="showExistingDocumentRow || pendingDocumentPdf"
									class="issue-document-list vehicle-media-doc-list"
								>
									<div v-if="showExistingDocumentRow" class="issue-document-row">
										<i class="fa issue-document-icon mr-2 fa-file-pdf-o text-danger" aria-hidden="true"></i>
										<div class="flex-grow-1 min-w-0">
											<a
												:href="existingDocumentsPdfUrl"
												target="_blank"
												rel="noopener noreferrer"
												class="text-body text-truncate d-block"
												:title="existingDocumentsPdfFileName"
											>{{ existingDocumentsPdfFileName }}</a>
											<small class="text-muted">PDF <span class="badge badge-light ml-1">Saved</span></small>
										</div>
										<button type="button" class="btn btn-link btn-sm p-0 text-danger ml-2" @click.stop="removeExistingDocumentPdf">Remove</button>
									</div>
									<div v-if="pendingDocumentPdf" class="issue-document-row">
										<i class="fa issue-document-icon mr-2" :class="documentIconClass(pendingDocumentPdf.name)" aria-hidden="true"></i>
										<div class="flex-grow-1 min-w-0">
											<span class="text-truncate d-block" :title="pendingDocumentPdf.name">{{ pendingDocumentPdf.name }}</span>
											<small class="text-muted">{{ documentTypeLabel(pendingDocumentPdf.name) }} · {{ pendingDocumentPdf.sizeLabel }}</small>
										</div>
										<button type="button" class="btn btn-link btn-sm p-0 text-danger ml-2" @click.stop="removePendingDocumentPdf">Remove</button>
									</div>
								</div>
								<input
									ref="documentPdfInput"
									id="default_documents_pdf"
									type="file"
									class="vehicle-media-file-input"
									:class="{ 'd-none': showExistingDocumentRow }"
									accept=".pdf,application/pdf"
									@change="onDocumentPdfFilesChange"
								>
								<button
									v-if="showExistingDocumentRow"
									type="button"
									class="btn btn-sm btn-outline-secondary mt-2"
									@click="triggerDocumentPdfPick"
								>Replace file</button>
								<small v-if="fileErrors.documents_pdf" class="text-danger d-block mt-1">{{ fileErrors.documents_pdf }}</small>
							</CCol>
						</CRow>
					</CCardBody>
				</CCard>
						<!--
						Legacy: separate OR / CR / Insurance / PA image uploads (replaced by single PDF).
						Restore this row and uncomment related script (dataParams, fileErrors, getFileInputFieldMap,
						validateSelectedFiles, getData URL mapping, submit files, VehicleController store/update) if needed.
						<CRow>
							<CCol lg="4">
								<label for="default_or_photo" class="ml-4">OR</label><br>
								<input type="file" class="ml-4" id="default_or_photo" style="width: 260px;" accept=".jpg,.jpeg,.png,.pdf"><br>
								<small v-if="fileErrors.or_photo" class="text-danger ml-4">{{ fileErrors.or_photo }}</small><br v-if="fileErrors.or_photo">
								<label class="ml-2" for="default_or_photo" style="max-height: 200px; max-width:200px;">
									<img class="m-3" style="max-height: 180px; max-width:200px; cursor: pointer" id="display_default_or_photo" src="https://t3.ftcdn.net/jpg/02/48/42/64/360_F_248426448_NVKLywWqArG2ADUxDq6QprtIzsF82dMF.jpg" v-if="!dataParams.or_photo">
									<img class="m-3" style="max-height: 180px; max-width:200px; cursor: pointer" id="display_default_or_photo" :src="dataParams.or_photo" v-else>
								</label>
							</CCol>
							<CCol lg="4">
								<label for="default_cr_photo" class="ml-4">CR</label><br>
								<input type="file" class="ml-4" id="default_cr_photo" style="width: 260px;" accept=".jpg,.jpeg,.png,.pdf"><br>
								<small v-if="fileErrors.cr_photo" class="text-danger ml-4">{{ fileErrors.cr_photo }}</small><br v-if="fileErrors.cr_photo">
								<label class="ml-2" for="default_cr_photo" style="max-height: 200px; max-width:200px;">
									<img class="m-3" style="max-height: 180px; max-width:200px; cursor: pointer" id="display_default_cr_photo" src="https://t3.ftcdn.net/jpg/02/48/42/64/360_F_248426448_NVKLywWqArG2ADUxDq6QprtIzsF82dMF.jpg" v-if="!dataParams.cr_photo">
									<img class="m-3" style="max-height: 180px; max-width:200px; cursor: pointer" id="display_default_cr_photo" :src="dataParams.cr_photo" v-else>
								</label>
							</CCol>
							<CCol lg="4">
								<label for="default_insurance_photo" class="ml-4">Insurance</label><br>
								<input type="file" class="ml-4" id="default_insurance_photo" style="width: 260px;" accept=".jpg,.jpeg,.png,.pdf"><br>
								<small v-if="fileErrors.insurance_photo" class="text-danger ml-4">{{ fileErrors.insurance_photo }}</small><br v-if="fileErrors.insurance_photo">
								<label class="ml-2" for="default_insurance_photo" style="max-height: 200px; max-width:200px;">
									<img class="m-3" style="max-height: 180px; max-width:200px; cursor: pointer" id="display_default_insurance_photo" src="https://t3.ftcdn.net/jpg/02/48/42/64/360_F_248426448_NVKLywWqArG2ADUxDq6QprtIzsF82dMF.jpg" v-if="!dataParams.insurance_photo">
									<img class="m-3" style="max-height: 180px; max-width:200px; cursor: pointer" id="display_default_insurance_photo" :src="dataParams.insurance_photo" v-else>
								</label>
							</CCol>
							<CCol lg="4">
								<label for="default_pa_photo" class="ml-4">PA</label><br>
								<input type="file" class="ml-4" id="default_pa_photo" style="width: 260px;" accept=".jpg,.jpeg,.png,.pdf"><br>
								<small v-if="fileErrors.pa_photo" class="text-danger ml-4">{{ fileErrors.pa_photo }}</small><br v-if="fileErrors.pa_photo">
								<label class="ml-2" for="default_pa_photo" style="max-height: 200px; max-width:200px;">
									<img class="m-3" style="max-height: 180px; max-width:200px; cursor: pointer" id="display_default_pa_photo" src="https://t3.ftcdn.net/jpg/02/48/42/64/360_F_248426448_NVKLywWqArG2ADUxDq6QprtIzsF82dMF.jpg" v-if="!dataParams.pa_photo">
									<img class="m-3" style="max-height: 180px; max-width:200px; cursor: pointer" id="display_default_pa_photo" :src="dataParams.pa_photo" v-else>
								</label>
							</CCol>
						</CRow>
						-->
				</CCardBody>
			</form>
		</CCard>
	</div>
</template>
<script>
import config from "../../config.js";
import axios from "../../axios";
import Swal from "sweetalert2";
import Search from "./search";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
// import 'vue-select/dist/vue-select.css';
import "../../style.css";
import moment from "moment";

export default {
  mounted() {
    this.getVendor();
    this.getVehicleType();
    this.getCommodityType();
    this.getCurrentLocation();
    this.getMakerModel();
    this.getVehicleModel();
    this.getDepot();
    this.getOrigin();
    this.getCustomer();	

    this.bindFileInputHandlers();
    // this.bindLegacyDocumentPhotoInputs();

    if (this.$route.params.id != undefined) {
      this.editMode = true;
    }
    if (this.$route.params.id) {
      this.getData();
    }
  },
  data() {
    return {
      formModal: false,
      showViewModal: false,
      dataList: [],
      dataListInactive: [],
      depotName: "",
      depot_id: JSON.parse(window.localStorage.getItem("user_data")).depot_id,
      dataParams: {
        vehicle_type_id: "",
        maker_model_id: "",
        origin_id: "",
        vendor_id: "",
        driver_id: "",
        body_no: "",
        year: "",
        with_gps: "no",
        company_owned: true,
        plate_no: "",
        registration_date: "",
        asset_no: "",
        engine_no: "",
        engine_size: "",
        chassis_no: "",
        transmission_type: "",
        transfer_date: "",
        color: "",
        fuel_type: "",
        later_renewal_date: "",
		pa_date:"",
        acquisition_date: "",
        acquisition_price: "",
        remarks: "",
        vehicle_photo: "",
        documents_pdf: "",
        // Legacy separate document uploads (re-enable template + script below + API handlers to use again):
        // or_photo: "",
        // cr_photo: "",
        // insurance_photo: "",
        // pa_photo: "",
        status: "ACTIVE",
        location:
          JSON.parse(window.localStorage.getItem("user_data")).depot_id != null
            ? JSON.parse(window.localStorage.getItem("user_data")).depot_id
            : "",
        breakdown_date: "",
        project_id: "",
		    current_location:"",

        mv_file_no: "",
        insurance_provider: "",
        insurance_policy_no: "",
        insurance_expiry: "",
        in_marine_policy_no: "",
        in_marine_expiry: "",
        ltfrb_case_no: "",
        ltfrb_expiry: "",
        cr_no: "",
        cr_date: "",
        or_no: "",
        or_date: "",
        commodity_type_id: "",
        registration_type: "",
        model_id: "",
		breakdown_remarks:"",
		rfid_account_no:"",
		rfid_type:"",
        category_type: ""
      },
      editMode: false,
      selectedRow: {},
      vendorList: {
        data: [],
      },
      vehicleTypeList: {
        data: [],
      },
      commodityTypeList: {
        data: [],
      },
      makerModelList: {
        data: [],
      },
      vehicleModelList: {
        data: [],
      },
      depotList: {
        data: [],
      },
      originList: {
        data: [],
      },
      customerList: {
        data: [],
      },
      currentLocationList: {
        data: [],
      },
      isLoading: false,
      uploadPercentage: 0,
      selectedDocumentsPdfName: "",
      selectedVehiclePhotoSizeLabel: "",
      selectedDocumentsPdfSizeLabel: "",
      existingDocumentCleared: false,
      savedDocumentsPdfUrl: "",
      savedDocumentsPdfName: "",
      maxFileSizeBytes: 5 * 1024 * 1024,
      maxPdfFileSizeBytes: 25 * 1024 * 1024,
      allowedVehiclePhotoTypes: ["jpg", "jpeg", "png"],
      fileErrors: {
        vehicle_photo: "",
        documents_pdf: "",
        // or_photo: "",
        // cr_photo: "",
        // insurance_photo: "",
        // pa_photo: "",
      },
      config,
    };
  },
  name: "Tables",
  components: { Search, Datepicker, vSelect },
  computed: {
    existingDocumentsPdfUrl() {
      const url = this.savedDocumentsPdfUrl || this.dataParams.documents_pdf;
      if (!url || typeof url !== "string" || !url.trim()) {
        return "";
      }
      return url.trim();
    },
    existingDocumentsPdfFileName() {
      if (this.savedDocumentsPdfName) {
        return this.savedDocumentsPdfName;
      }
      const url = this.existingDocumentsPdfUrl;
      if (!url) {
        return "Vehicle documents.pdf";
      }
      try {
        const path = url.split("?")[0].split("/");
        const last = path[path.length - 1] || "";
        if (last.toLowerCase().endsWith(".pdf")) {
          return decodeURIComponent(last);
        }
      } catch (e) {
        /* ignore */
      }
      return "Vehicle documents.pdf";
    },
    showExistingDocumentRow() {
      return (
        this.editMode &&
        !!this.existingDocumentsPdfUrl &&
        !this.existingDocumentCleared &&
        !this.selectedDocumentsPdfName
      );
    },
    pendingDocumentPdf() {
      if (!this.selectedDocumentsPdfName) {
        return null;
      }
      return {
        name: this.selectedDocumentsPdfName,
        sizeLabel: this.selectedDocumentsPdfSizeLabel || "",
      };
    },
  },
  methods: {
    getFileInputFieldMap() {
      return {
        vehicle_photo: "default_vehicle_photo",
        documents_pdf: "default_documents_pdf",
        // or_photo: "default_or_photo",
        // cr_photo: "default_cr_photo",
        // insurance_photo: "default_insurance_photo",
        // pa_photo: "default_pa_photo",
      };
    },
    getInputFileByField(fieldName) {
      const inputId = this.getFileInputFieldMap()[fieldName];
      const input = inputId ? document.getElementById(inputId) : null;
      return input && input.files ? input.files[0] : null;
    },
    clearFileErrors() {
      Object.keys(this.fileErrors).forEach((field) => {
        this.fileErrors[field] = "";
      });
    },
    formatFileSize(bytes) {
      if (bytes == null || bytes === "" || Number.isNaN(Number(bytes))) {
        return "";
      }
      const b = Number(bytes);
      if (b <= 0) {
        return "0 B";
      }
      if (b < 1024) {
        return `${b} B`;
      }
      if (b < 1024 * 1024) {
        return `${(b / 1024).toFixed(2)} KB`;
      }
      return `${(b / (1024 * 1024)).toFixed(2)} MB`;
    },
    validateVehiclePhotoFile(file) {
      if (!file) {
        return "";
      }

      if (file.size > this.maxFileSizeBytes) {
        return "File is too large (max 5MB).";
      }

      const fileName = (file.name || "").toLowerCase();
      const extension = fileName.includes(".")
        ? fileName.split(".").pop()
        : "";
      if (!this.allowedVehiclePhotoTypes.includes(extension)) {
        return "Vehicle picture must be JPG or PNG.";
      }

      return "";
    },
    validateDocumentsPdfFile(file) {
      if (!file) {
        return "";
      }

      if (file.size > this.maxPdfFileSizeBytes) {
        return "PDF is too large (max 25MB).";
      }

      const fileName = (file.name || "").toLowerCase();
      const extension = fileName.includes(".")
        ? fileName.split(".").pop()
        : "";
      if (extension !== "pdf") {
        return "Vehicle documents must be a single PDF file.";
      }

      return "";
    },
    validateSelectedFiles() {
      let hasError = false;
      const vehicleFile = this.getInputFileByField("vehicle_photo");
      this.fileErrors.vehicle_photo = this.validateVehiclePhotoFile(vehicleFile);
      if (this.fileErrors.vehicle_photo) {
        hasError = true;
      }

      const pdfFile = this.getInputFileByField("documents_pdf");
      this.fileErrors.documents_pdf = this.validateDocumentsPdfFile(pdfFile);
      if (this.fileErrors.documents_pdf) {
        hasError = true;
      }

      /*
      const legacyAllowed = ["jpg", "jpeg", "png", "pdf"];
      const validateLegacyFile = (file) => {
        if (!file) return "";
        if (file.size > this.maxFileSizeBytes) return "File is too large (max 5MB).";
        const ext = (file.name || "").toLowerCase().split(".").pop();
        if (!legacyAllowed.includes(ext)) return "Invalid file type. Allowed: JPG, PNG, PDF.";
        return "";
      };
      ["or_photo", "cr_photo", "insurance_photo", "pa_photo"].forEach((field) => {
        const f = this.getInputFileByField(field);
        this.fileErrors[field] = validateLegacyFile(f);
        if (this.fileErrors[field]) hasError = true;
      });
      */

      return !hasError;
    },
    bindFileInputHandlers() {
      const inputId = "default_vehicle_photo";
      const input = document.getElementById(inputId);
      if (!input) {
        return;
      }

      input.onchange = () => {
        const file = input.files ? input.files[0] : null;
        const validationError = this.validateVehiclePhotoFile(file);
        this.fileErrors.vehicle_photo = validationError;

        if (!file || validationError) {
          this.selectedVehiclePhotoSizeLabel = "";
          if (validationError) {
            input.value = "";
          }
          return;
        }

        this.selectedVehiclePhotoSizeLabel = this.formatFileSize(file.size);

        if (file.type && file.type.indexOf("image/") !== 0) {
          this.selectedVehiclePhotoSizeLabel = "";
          return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = function () {
          const displayElement = document.getElementById(
            `display_${inputId}`
          );
          if (displayElement) {
            displayElement.src = reader.result;
          }
        }.bind(this);
      };
    },
    triggerDocumentPdfPick() {
      const input =
        this.$refs.documentPdfInput ||
        document.getElementById("default_documents_pdf");
      if (input) {
        input.click();
      }
    },
    onDocumentPdfFilesChange(e) {
      const file = e.target.files ? e.target.files[0] : null;
      this.applyDocumentPdfFile(file);
    },
    applyDocumentPdfFile(file) {
      if (!file) {
        return;
      }
      const validationError = this.validateDocumentsPdfFile(file);
      this.fileErrors.documents_pdf = validationError;
      const input = this.$refs.documentPdfInput;
      if (!file || validationError) {
        if (validationError && input) {
          input.value = "";
        }
        this.selectedDocumentsPdfName = "";
        this.selectedDocumentsPdfSizeLabel = "";
        return;
      }
      if (input && typeof DataTransfer !== "undefined") {
        try {
          const dt = new DataTransfer();
          dt.items.add(file);
          input.files = dt.files;
        } catch (err) {
          /* ignore — change event already has the file */
        }
      }
      this.selectedDocumentsPdfName = file.name;
      this.selectedDocumentsPdfSizeLabel = this.formatFileSize(file.size);
    },
    removePendingDocumentPdf() {
      const input = this.$refs.documentPdfInput;
      if (input) {
        input.value = "";
      }
      this.selectedDocumentsPdfName = "";
      this.selectedDocumentsPdfSizeLabel = "";
      this.fileErrors.documents_pdf = "";
    },
    removeExistingDocumentPdf() {
      this.existingDocumentCleared = true;
      this.savedDocumentsPdfUrl = "";
      this.savedDocumentsPdfName = "";
      this.dataParams.documents_pdf = "";
    },
    fileNameFromStoragePath(path) {
      if (!path || typeof path !== "string") {
        return "";
      }
      const normalized = path.trim().replace(/\\/g, "/");
      const parts = normalized.split("/");
      const last = parts[parts.length - 1] || "";
      return last ? decodeURIComponent(last) : "";
    },
    resolveVehicleMediaUrl(fieldName) {
      const s3FieldName = fieldName + "_s3";
      const rawS3 = this.dataParams[s3FieldName];
      const localValue = this.dataParams[fieldName];
      const apiBase = config.main_path.replace("/index.php", "");
      const baseUploadPath = apiBase + "/uploads/";

      if (rawS3 != null && rawS3 !== false && rawS3 !== 0 && rawS3 !== "0") {
        const s3Str = String(rawS3).trim();
        if (s3Str && s3Str !== "0" && /^https?:\/\//i.test(s3Str)) {
          return s3Str;
        }
      }

      if (localValue == null || localValue === "") {
        return "";
      }
      if (typeof localValue !== "string" && typeof localValue !== "number") {
        return "";
      }

      const normalizedValue = String(localValue)
        .trim()
        .replace(/\\/g, "/")
        .replace(/^\/+/, "");

      if (
        normalizedValue.startsWith("http://") ||
        normalizedValue.startsWith("https://") ||
        normalizedValue.startsWith("data:")
      ) {
        return normalizedValue;
      }

      if (normalizedValue.indexOf("vehicle-upload-fallback/") === 0) {
        return apiBase + "/storage/" + normalizedValue.replace(/^\/+/, "");
      }

      if (/^[a-zA-Z]:\//.test(normalizedValue)) {
        const uploadMarker = "/uploads/";
        const uploadMarkerIndex = normalizedValue
          .toLowerCase()
          .indexOf(uploadMarker);
        if (uploadMarkerIndex >= 0) {
          const relativeFromUploads = normalizedValue.substring(
            uploadMarkerIndex + uploadMarker.length
          );
          return baseUploadPath + relativeFromUploads.replace(/^\/+/, "");
        }
        const parts = normalizedValue.split("/");
        const fileName = parts[parts.length - 1];
        return baseUploadPath + fileName;
      }

      if (
        normalizedValue.startsWith("uploads/") ||
        normalizedValue.startsWith("storage/")
      ) {
        return apiBase + "/" + normalizedValue;
      }

      const relativePath = normalizedValue.replace(/^uploads\//, "");
      return baseUploadPath + relativePath;
    },
    documentExt(name) {
      return String(name || "").split(".").pop().toLowerCase();
    },
    documentIconClass(name) {
      const ext = this.documentExt(name);
      if (ext === "pdf") return "fa-file-pdf-o text-danger";
      if (ext === "doc" || ext === "docx") return "fa-file-word-o text-primary";
      if (ext === "xls" || ext === "xlsx") return "fa-file-excel-o text-success";
      if (ext === "txt") return "fa-file-text-o text-muted";
      return "fa-file-o text-muted";
    },
    documentTypeLabel(name) {
      const ext = this.documentExt(name);
      const map = { pdf: "PDF", doc: "Word", docx: "Word", xls: "Excel", xlsx: "Excel", txt: "Text" };
      return map[ext] || (ext ? ext.toUpperCase() : "File");
    },
    /*
    // Legacy: bind OR/CR/Insurance/PA file inputs (call from mounted after uncommenting template + fields).
    bindLegacyDocumentPhotoInputs() {
      const fileInputFieldMap = {
        or_photo: "default_or_photo",
        cr_photo: "default_cr_photo",
        insurance_photo: "default_insurance_photo",
        pa_photo: "default_pa_photo",
      };
      const validateLegacyFile = (file) => {
        if (!file) return "";
        if (file.size > this.maxFileSizeBytes) return "File is too large (max 5MB).";
        const ext = (file.name || "").toLowerCase().split(".").pop();
        if (!["jpg", "jpeg", "png", "pdf"].includes(ext)) return "Invalid file type. Allowed: JPG, PNG, PDF.";
        return "";
      };
      Object.keys(fileInputFieldMap).forEach((field) => {
        const inputId = fileInputFieldMap[field];
        const input = document.getElementById(inputId);
        if (!input) return;
        input.onchange = () => {
          const file = input.files ? input.files[0] : null;
          const validationError = validateLegacyFile(file);
          this.fileErrors[field] = validationError;
          if (!file || validationError) {
            if (validationError) input.value = "";
            return;
          }
          if (file.type && file.type.indexOf("image/") !== 0) return;
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = function () {
            const displayElement = document.getElementById("display_" + inputId);
            if (displayElement) displayElement.src = reader.result;
          }.bind(this);
        };
      });
    },
    */
    mapValidationErrorsToFields(errorData) {
      const fileFields = Object.keys(this.fileErrors);
      if (!errorData) {
        return;
      }
      const validationErrors = errorData.errors || errorData.error || {};
      fileFields.forEach((field) => {
        const fieldError = validationErrors[field];
        if (Array.isArray(fieldError) && fieldError.length) {
          this.fileErrors[field] = fieldError[0];
        } else if (typeof fieldError === "string") {
          this.fileErrors[field] = fieldError;
        }
      });
    },
    isStorageErrorResponse(errorResponse) {
      if (!errorResponse || !errorResponse.status) {
        return false;
      }
      if (![500, 503].includes(errorResponse.status)) {
        return false;
      }
      const messageSource = String(
        (errorResponse.data && (errorResponse.data.message || errorResponse.data.error)) || ""
      ).toLowerCase();
      return (
        messageSource.includes("storage") ||
        messageSource.includes("upload") ||
        messageSource.includes("s3")
      );
    },
    getBackendErrorCode(errorResponse) {
      if (!errorResponse || !errorResponse.data) {
        return "";
      }
      const codeSource =
        errorResponse.data.code ||
        errorResponse.data.error_code ||
        errorResponse.data.message_code ||
        "";
      return String(codeSource).toUpperCase();
    },
    normalizeNullableDataParams() {
      for (const d in this.dataParams) {
        this.dataParams[d] = this.dataParams[d] ?? "";
      }
    },
    buildVehicleRequestPayload() {
      const payload = {
        body_no: this.dataParams.body_no,
        year: this.dataParams.year,
        with_gps: this.dataParams.with_gps,
        company_owned: this.dataParams.company_owned ? 1 : 0,
        plate_no: this.dataParams.plate_no,
        asset_no: this.dataParams.asset_no,
        engine_no: this.dataParams.engine_no,
        engine_size: this.dataParams.engine_size,
        chassis_no: this.dataParams.chassis_no,
        transmission_type: this.dataParams.transmission_type,
        color: this.dataParams.color,
        fuel_type: this.dataParams.fuel_type,
        acquisition_price: this.dataParams.acquisition_price,
        remarks: this.dataParams.remarks,
        status: this.dataParams.status,
        location: this.dataParams.location,
        breakdown_remarks: this.dataParams.breakdown_remarks,
        rfid_type: this.dataParams.rfid_type,
        rfid_account_no: this.dataParams.rfid_account_no,
        mv_file_no: this.dataParams.mv_file_no,
        insurance_provider: this.dataParams.insurance_provider,
        insurance_policy_no: this.dataParams.insurance_policy_no,
        in_marine_policy_no: this.dataParams.in_marine_policy_no,
        ltfrb_case_no: this.dataParams.ltfrb_case_no,
        cr_no: this.dataParams.cr_no,
        or_no: this.dataParams.or_no,
        commodity_type_id: this.dataParams.commodity_type_id,
        registration_type: this.dataParams.registration_type,
        model_id: this.dataParams.model_id,
        category_type: this.dataParams.category_type,
      };

      if (this.dataParams.project_id !== "" && this.dataParams.project_id != null) {
        payload.project_id = this.dataParams.project_id;
      }
      if (
        this.dataParams.current_location !== "" &&
        this.dataParams.current_location != null
      ) {
        payload.current_location_id =
          typeof this.dataParams.current_location === "number"
            ? this.dataParams.current_location
            : this.dataParams.current_location.id;
      }
      if (
        this.dataParams.vehicle_type_id !== "" &&
        this.dataParams.vehicle_type_id != null
      ) {
        payload.vehicle_type_id = this.dataParams.vehicle_type_id;
      }
      if (
        this.dataParams.maker_model_id !== "" &&
        this.dataParams.maker_model_id != null
      ) {
        payload.maker_model_id = this.dataParams.maker_model_id;
      }
      if (this.dataParams.origin_id !== "" && this.dataParams.origin_id != null) {
        payload.origin_id = this.dataParams.origin_id;
      }
      if (this.dataParams.driver_id !== "" && this.dataParams.driver_id != null) {
        payload.driver_id = this.dataParams.driver_id;
      }

      if (
        this.dataParams.registration_date !== "" &&
        this.dataParams.registration_date != null
      ) {
        payload.registration_date = moment(this.dataParams.registration_date).format(
          "YYYY-MM-DD"
        );
      }
      if (
        this.dataParams.breakdown_date !== "" &&
        this.dataParams.breakdown_date != null
      ) {
        payload.breakdown_date = moment(this.dataParams.breakdown_date).format(
          "YYYY-MM-DD"
        );
      }
      if (
        this.dataParams.transfer_date !== "" &&
        this.dataParams.transfer_date != null
      ) {
        payload.transfer_date = moment(this.dataParams.transfer_date).format(
          "YYYY-MM-DD"
        );
      }
      if (
        this.dataParams.later_renewal_date !== "" &&
        this.dataParams.later_renewal_date != null
      ) {
        payload.later_renewal_date = moment(this.dataParams.later_renewal_date).format(
          "YYYY-MM-DD"
        );
      }
      if (
        this.dataParams.acquisition_date !== "" &&
        this.dataParams.acquisition_date != null
      ) {
        payload.acquisition_date = moment(this.dataParams.acquisition_date).format(
          "YYYY-MM-DD"
        );
      }
      if (
        this.dataParams.insurance_expiry !== "" &&
        this.dataParams.insurance_expiry != null
      ) {
        payload.insurance_expiry = moment(this.dataParams.insurance_expiry).format(
          "YYYY-MM-DD"
        );
      }
      if (
        this.dataParams.in_marine_expiry !== "" &&
        this.dataParams.in_marine_expiry != null
      ) {
        payload.in_marine_expiry = moment(this.dataParams.in_marine_expiry).format(
          "YYYY-MM-DD"
        );
      }
      if (
        this.dataParams.ltfrb_expiry !== "" &&
        this.dataParams.ltfrb_expiry != null
      ) {
        payload.ltfrb_expiry = moment(this.dataParams.ltfrb_expiry).format(
          "YYYY-MM-DD"
        );
      }
      if (this.dataParams.cr_date !== "" && this.dataParams.cr_date != null) {
        payload.cr_date = moment(this.dataParams.cr_date).format("YYYY-MM-DD");
      }
      if (this.dataParams.or_date !== "" && this.dataParams.or_date != null) {
        payload.or_date = moment(this.dataParams.or_date).format("YYYY-MM-DD");
      }
      if (this.dataParams.pa_date !== "" && this.dataParams.pa_date != null) {
        payload.pa_date = moment(this.dataParams.pa_date).format("YYYY-MM-DD");
      }

      if (this.dataParams.vendor_id !== "" && this.dataParams.vendor_id != null) {
        payload.vendor_id = this.dataParams.company_owned
          ? null
          : this.dataParams.vendor_id;
      }

      return payload;
    },
    buildFormDataFromPayload(payload, files = {}) {
      const formData = new FormData();
      Object.keys(payload).forEach((key) => {
        formData.append(key, payload[key]);
      });
      Object.keys(files).forEach((key) => {
        if (files[key]) {
          formData.append(key, files[key]);
        }
      });
      return formData;
    },
    backToTable() {
      this.$router.push("/data/vehicle");
    },

    getData(){
			this.$showLoading(true)
			axios.get(config.api_path+"/vehicle/"+this.$route.params.id)
			.then(response=>{
				this.$showLoading(false)
				this.dataParams = response.data.data;
				console.log(this.dataParams)
				if(this.dataParams.with_gps == 1){
					this.dataParams.with_gps = "yes";
				}
				else{
					this.dataParams.with_gps = "no";
				}

				const rawDocumentsPdf = this.dataParams.documents_pdf;
				this.savedDocumentsPdfName = this.fileNameFromStoragePath(rawDocumentsPdf);
				this.dataParams.vehicle_photo = this.resolveVehicleMediaUrl("vehicle_photo");
				this.savedDocumentsPdfUrl = this.resolveVehicleMediaUrl("documents_pdf");
				this.dataParams.documents_pdf = this.savedDocumentsPdfUrl;

				// Legacy separate document images (edit preview) — uncomment with template + API:
				// if(this.dataParams.cr_photo_s3 == 0)
				// 	this.dataParams.cr_photo = this.dataParams.cr_photo ? config.main_path.replace('/index.php', '')+'/uploads/'+this.dataParams.cr_photo : '';
				// else
				// 	this.dataParams.cr_photo = this.dataParams.cr_photo_s3;
				// if(this.dataParams.or_photo_s3 == 0)
				// 	this.dataParams.or_photo = this.dataParams.or_photo ? config.main_path.replace('/index.php', '')+'/uploads/'+this.dataParams.or_photo : '';
				// else
				// 	this.dataParams.or_photo = this.dataParams.or_photo_s3;
				// if(this.dataParams.insurance_photo_s3 == 0)
				// 	this.dataParams.insurance_photo = this.dataParams.insurance_photo ? config.main_path.replace('/index.php', '')+'/uploads/'+this.dataParams.insurance_photo : '';
				// else
				// 	this.dataParams.insurance_photo = this.dataParams.insurance_photo_s3;
				// if(this.dataParams.pa_photo_s3 == 0)
				// 	this.dataParams.pa_photo = this.dataParams.pa_photo ? config.main_path.replace('/index.php', '')+'/uploads/'+this.dataParams.pa_photo : "";
				// else
				// 	this.dataParams.pa_photo = this.dataParams.pa_photo_s3;

				this.selectedDocumentsPdfName = "";
				this.selectedDocumentsPdfSizeLabel = "";
				this.selectedVehiclePhotoSizeLabel = "";
				this.existingDocumentCleared = false;
				if (!this.savedDocumentsPdfUrl) {
					this.savedDocumentsPdfName = "";
				}
				this.dataParams.model_id = this.dataParams.model_id ? parseInt(this.dataParams.model_id) : null;
				this.dataParams.commodity_type_id = (this.dataParams.commodity_type_id) ? parseInt(this.dataParams.commodity_type_id) : this.dataParams.commodity_type_id;
				this.dataParams.location = this.dataParams.location ? parseInt(this.dataParams.location) : this.dataParams.location;
			})
			.catch(err => {
			this.$showLoading(false)
		}) 
  },
    submit() {
      if (this.isLoading) {
        return;
      }

      this.clearFileErrors();
      if (!this.validateSelectedFiles()) {
        return;
      }

      this.isLoading = true;
      this.uploadPercentage = 0;

      this.normalizeNullableDataParams();
      const payload = this.buildVehicleRequestPayload();
      const files = {
        vehicle_photo: this.getInputFileByField("vehicle_photo"),
        documents_pdf: this.getInputFileByField("documents_pdf"),
        // or_photo: this.getInputFileByField("or_photo"),
        // cr_photo: this.getInputFileByField("cr_photo"),
        // insurance_photo: this.getInputFileByField("insurance_photo"),
        // pa_photo: this.getInputFileByField("pa_photo"),
      };
      const hasFiles = Object.keys(files).some((key) => {
        const file = files[key];
        return file instanceof File || file instanceof Blob;
      });

      const isUpdateMode = !!this.editMode;
      const updatePath = config.api_path + "/vehicle/" + this.$route.params.id;
      const createPath = config.api_path + "/vehicle";

      let request;
      if (isUpdateMode && !hasFiles) {
        request = axios.put(updatePath, payload);
      } else {
        const formData = this.buildFormDataFromPayload(payload, files);
        request = axios.post(isUpdateMode ? updatePath : createPath, formData, {
          onUploadProgress: (prog) => {
            const total = prog.total || 0;
            const uploadPercentage = total
              ? parseInt(Math.round((prog.loaded / total) * 100))
              : 0;
            this.uploadPercentage = uploadPercentage;
          },
        });
      }

      request
        .then((response) => {
          if (response.data.status == "failed") {
            Swal.fire({
              title: "Error!",
              text: response.data.message,
              icon: "error",
            });
            this.isLoading = false;
            return;
          }
          var text = "Vehicle successfully added!";
          if (this.editMode) {
            text = "Vehicle successfully updated!";
          }
          Swal.fire({
            title: "Success!",
            text,
            icon: "success",
          });
          this.formModal = false;
          this.editMode = false;
          this.dataParams = {
            vehicle_type_id: "",
            maker_model_id: "",
            origin_id: "",
            vendor_id: "",
            driver_id: "",
            body_no: "",
            year: "",
            with_gps: "",
            company_owned: true,
            plate_no: "",
            registration_date: "",
            asset_no: "",
            engine_no: "",
            engine_size: "",
            chassis_no: "",
            transmission_type: "",
            transfer_date: "",
            color: "",
            fuel_type: "",
            later_renewal_date: "",
            acquisition_date: "",
            acquisition_price: "",
            remarks: "",
            vehicle_photo: "",
            documents_pdf: "",
            // or_photo: "",
            // cr_photo: "",
            // insurance_photo: "",
            // pa_photo: "",
            status: "ACTIVE",
            location: "",
            commodity_type_id: "",
            registration_type: "",            
            model_id: "",
          
            breakdown_remarks:"",
            rfid_account_no:"",
            rfid_type:"",
            category_type: null,

          };
          // this.getData();
          // this.getDataInactive();
          this.isLoading = false;
          this.uploadPercentage = 0;
          this.$router.push("/data/view_vehicle/" + response.data.data.id);
        })
        .catch((e) => {
          const errorResponse = e.response;
          const errorCode = this.getBackendErrorCode(errorResponse);
          if (errorResponse && errorResponse.status === 422) {
            this.mapValidationErrorsToFields(errorResponse.data);
          } else if (
            errorResponse &&
            errorResponse.status === 503 &&
            errorCode === "UPLOAD_WRITE_FAILED"
          ) {
            Swal.fire({
              title: "Upload unavailable",
              text: "Upload service is temporarily unavailable. Please try again later.",
              icon: "error",
            });
          } else if (
            errorResponse &&
            errorResponse.status === 500 &&
            errorCode === "UPLOAD_STORAGE_MISCONFIGURED"
          ) {
            Swal.fire({
              title: "Storage configuration error",
              text: "Upload storage configuration is unavailable. Please contact support.",
              icon: "error",
            });
          } else if (this.isStorageErrorResponse(errorResponse)) {
            Swal.fire({
              title: "Error!",
              text: "Upload service is temporarily unavailable. Please try again later.",
              icon: "error",
            });
          }
          this.isLoading = false;
          this.uploadPercentage = 0;
        });
    },
    locationChanged(ev) {
			let depot = [], depot_id = '';
			let customer = this.customerList.data.filter(item => item.id == ev);
			if(customer.length) {
				depot_id = customer[0].depot_id;
			}
			depot = this.depotList.data.filter(item => item.id == depot_id);
			
			if(depot.length) {
				this.dataParams.depot = depot[0];
				this.dataParams.depot_id = depot[0].id;
			}
			else {
				this.dataParams.depot = null;
				this.dataParams.depot_id = null;
			}
		},

		 getVendor(){

          axios.get(config.api_path+'/reference/subconvendors-list')
          .then(response => {
            this.vendorList = response.data; 
          })

        },

    // getVendor() {
    //   axios
    //     .get(config.api_path + "/vendor?page=1&limit=10000000")
    //     // axios.get(config.api_path+'/vendor?page=1&limit=10000000')
    //     .then((response) => {
    //       this.vendorList = response.data;
    //       this.vendorList.data = this.vendorList.data.map((value, index) => {
    //         value.value = value.id;
    //         value.label = value.vendor_name;
    //         return value;
    //       });
    //       this.vendorList.data = this.vendorList.data.filter((value, index) => {
    //         return (
    //           value.vendor_type_name.setting_name.toLowerCase() ==
    //             "trucking services" ||
    //           value.vendor_type_name.setting_name.toLowerCase() == "trucker"
    //         );
    //       });
    //     });
    // },

    getVehicleType() {
      axios
        .get(config.api_path + "/reference/settings-list", {
          params: {
            setting_type: "vehicle_type",
          },
        })
        .then((response) => {
          this.vehicleTypeList = response.data;
        });

      // axios.get(config.api_path+'/setting?setting_type=vehicle_type&page=1&limit=10000000')
      // .then(response => {
      // 	this.vehicleTypeList = response.data;
      // })
    },
    getCommodityType() {
      axios
        .get(config.api_path + "/reference/settings-list", {
          params: {
            setting_type: "commodity_type",
          },
        })
        .then((response) => {
          this.commodityTypeList = response.data;
        });
			// formData.append('company_owned', this.dataParams.company_owned ? 1 : 0);
	    // 	if(this.dataParams.vendor_id != "" && this.dataParams.vendor_id != null){
			// 	if(this.dataParams.company_owned) {
			// 		// formData.append('vendor_id', null);
			// 	}
	    // 		else formData.append('vendor_id', this.dataParams.vendor_id);
	    // 	}
	    	

      // axios.get(config.api_path+'/setting?setting_type=commodity_type&page=1&limit=10000000')
      // .then(response => {
      // 	this.commodityTypeList = response.data;
      // })
    },

    getMakerModel() {
      axios
        .get(config.api_path + "/reference/settings-list", {
          params: {
            setting_type: "maker_model",
          },
        })
        .then((response) => {
          this.makerModelList = response.data;
        });

      // axios.get(config.api_path+'/setting?setting_type=maker_model&page=1&limit=10000000')
      // .then(response => {
      // 	this.makerModelList = response.data;
      // })
    },
    getVehicleModel() {
      axios
        .get(config.api_path + "/reference/settings-list", {
          params: {
            setting_type: "vehicle_model",
          },
        })
        .then((response) => {
          this.vehicleModelList = response.data;
        });

      // axios.get(config.api_path+'/setting?setting_type=vehicle_model&page=1&limit=10000000')
      // .then(response => {
      // 	this.vehicleModelList = response.data;
      // })
    },

    getDepot(){

          axios.get(config.api_path+'/reference/settings-list',{
            params:{
              setting_type:'depot'
            }
          })
        .then(response => {
          this.depotList = response.data;
        

        let depot_id = this.depot_id;//this.user_data?.depot_id;
        if(depot_id) {
          this.depotList.data = this.depotList.data.filter(item => item.id == depot_id)
          let depot = this.depotList.data.filter(item => item.id == depot_id);
          if(depot.length) {
          this.$set(this.dataParams,'depot',depot[0])

          this.dataParams.depot_id = depot_id;
        }
        }
        })

        },
    getOrigin() {
      axios
        .get(config.api_path + "/reference/settings-list", {
          params: {
            setting_type: "origin",
          },
        })
        .then((response) => {
          this.originList = response.data;
        });
    },

    // getOrigin(){

    // 	axios.get(config.api_path+'/setting?setting_type=origin&page=1&limit=10000000')
    // 	.then(response => {
    // 		this.originList = response.data;
    // 	})

    // },
    getCustomer() {
      axios
        .get(config.api_path + "/reference/customer-list", {
          params: {
            show_all: true,			
          },
        })
        .then((response) => {
          this.customerList = response.data;
      
                    
        });
    },
    getCurrentLocation() {
      axios
        .get(config.api_path + "/reference/customer-list", {
          params: {
            show_all: true,			
          },
        })
        .then((response) => {
          this.currentLocationList = response.data;
          this.currentLocationList.data = this.currentLocationList.data.filter(i => i.depot_id == this.depot_id || !this.depot_id)
                    
        });
    },
        
    updateCompanyOwned(e) {
      this.dataParams.company_owned = e;
    },
  },
};
</script>
<style scoped>
.vehicle-media-card {
  border: 1px solid #dfe3eb;
  border-radius: 12px;
  box-shadow: none;
}

.vehicle-media-card-body {
  min-height: 0;
}

.vehicle-media-card-title {
  font-size: 14px;
  font-weight: 600;
  color: #2d3648;
  margin-bottom: 0;
}

.vehicle-media-label {
  display: block;
  font-weight: 600;
  font-size: 13px;
  color: #3f4d67;
  margin-bottom: 4px;
}

.vehicle-media-hint {
  font-size: 12px;
  line-height: 1.35;
  margin-bottom: 6px;
}

.vehicle-media-file-input {
  display: block;
  width: 100%;
  max-width: 260px;
  margin-top: 6px;
  margin-bottom: 8px;
  font-size: 13px;
}

.vehicle-photo-preview-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 140px;
  height: 120px;
  margin-top: 4px;
  border: 1px dashed #cfd6e4;
  border-radius: 8px;
  background: #f8f9fb;
  overflow: hidden;
  cursor: pointer;
}

.vehicle-photo-preview-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.vehicle-media-photo-col {
  padding-bottom: 0;
}

.vehicle-media-docs-col {
  padding-bottom: 0;
}

.vehicle-media-doc-list {
  margin-top: 8px;
  max-width: 480px;
}

.issue-document-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.issue-document-row {
  display: flex;
  align-items: center;
  border: 1px solid #e5e8ee;
  border-radius: 6px;
  padding: 8px 10px;
  background: #fff;
}
.issue-document-icon {
  font-size: 1.25rem;
  width: 1.5rem;
  text-align: center;
}
.min-w-0 {
  min-width: 0;
}
</style>
